import image1 from "./assests/1.jpg";
import image2 from "./assests/2.jpg";
import image3 from "./assests/3.jpg";
import image4 from "./assests/4.jpg";
import image5 from "./assests/5.jpeg";

export default [image1, image2, image3, image4, image5];
